import clsx from 'clsx'
import Image from 'next/image'

/* blocks */
import Link from '@/atoms/Link/Link'

/* assets */
import BookSaved from 'public/assets/global-marketing-leaders/book-saved.png'

/* styling */
import styles from './_.module.css'

interface Props {
  primaryHeadline: string
  primaryCta: StrapiLinkSharedComponent | null
  image?: {
    url: string
    alternativeText?: string
    height?: number
    width?: number
  }
  tag?: string
}

function InfluencerFooterCta({
  primaryHeadline,
  primaryCta,
  image,
  tag
}: Props): JSX.Element {
  return (
    <section className={clsx('bg-[#FFE599]')}>
      <div className="max-width-container grid lg:grid-rows-6 grid-cols-4 lg:grid-cols-12 | relative">
        <Image
          src="/assets/global-marketing-leaders/circle-triangle-rotate.svg"
          alt=""
          width={90}
          height={234}
          className="lg:hidden | absolute top-0 right-0"
        />
        <Image
          src="/assets/global-marketing-leaders/pill-square-rotate.svg"
          alt=""
          width={113}
          height={234}
          className="lg:hidden | absolute bottom-0"
        />
        <div className="col-span-4 lg:col-span-5 lg:col-start-2 justify-self-center lg:justify-self-stretch  lg:row-span-3 lg:self-center lg:order-2 px-10 pt-24 lg:p-0">
          {tag ? (
            <div className="flex items-center text-blue-web-50 | pb-9 lg:pb-4">
              <Image
                src={BookSaved.src}
                alt=""
                width={BookSaved.width}
                height={BookSaved.height}
                className="w-7 h-7"
              />
              <p className="uppercase text-lg font-semibold | ml-3">{tag}</p>
            </div>
          ) : null}
          {primaryHeadline ? (
            <h1
              className="font-body font-medium text-2xl md:text-3xl text-blue-web-90 | tracking-tight"
              dangerouslySetInnerHTML={{ __html: primaryHeadline }}
            />
          ) : null}
        </div>
        <div className="col-span-4 lg:col-start-8 lg:row-span-6 | lg:order-1">
          <div className="relative">
            {image && (
              <Image
                src={image.url}
                alt={image.alternativeText ?? ''}
                width={image.width}
                height={image.height}
                className="rounded-2xl | w-full max-w-[418px] max-h-[400px] mx-auto | relative | z-20"
              />
            )}
            <div className="flex | z-10">
              <Image
                src="/assets/global-marketing-leaders/circle-triangle.svg"
                alt=""
                width={297}
                height={255}
                className={clsx(
                  'hidden lg:block my-18 | absolute top-[112px] -left-[130px]',
                  styles.circleTriangle
                )}
              />
              <Image
                src="/assets/global-marketing-leaders/pill-square.svg"
                alt=""
                width={136}
                height={329}
                className={clsx(
                  'hidden lg:block my-18 | absolute top-[68px] left-80',
                  styles.pillSquare
                )}
              />
            </div>
          </div>
        </div>
        {primaryCta ? (
          <div className="col-span-4 lg:col-span-5 lg:col-start-2  max-w-col-4 justify-self-center lg:justify-self-stretch lg:row-span-3 lg:order-3 pt-6 pb-12 lg:p-0">
            <Link
              href={primaryCta.href}
              className="text-small md:text-xl font-medium bg-blue-50 text-white | inline-flex items-center justify-center | max-h-14 w-full px-16 py-4 | rounded-full"
            >
              {primaryCta.title}
            </Link>
          </div>
        ) : null}
      </div>
    </section>
  )
}

export default InfluencerFooterCta
